import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { SnackService } from '../../services/snack.service';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  passwordResetForm: any;
  message: string;

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private snackService: SnackService
  ) {
    super();
    this.passwordResetForm = this.fb.group({
      email: ['', [Validators.required]],
      persist: [false, []],
    });
  }

  ngOnInit() {}

  requestAccountRecovery() {
    this.authService.requestAccountRecovery(this.passwordResetForm.value.email);
    this.addSubscription(this.authService.recoveryEvent, (success: boolean) => {
      if (success) {
        this.snackService.showSuccess(
          'Er is een e-mail verzonden naar het opgegeven e-mailadres. Gelieve de instructies te volgen.'
        );
      } else {
        this.snackService.showError(
          'Er is geen gebruiker voor dit e-mailadres'
        );
      }
    });
  }
}
